import CommentIcon from "@mui/icons-material/Comment";
import { default as EditIcon } from "@mui/icons-material/Edit";
import {
    Box,
    Button,
    Checkbox,
    Dialog,
    DialogContent,
    DialogContentText,
    FormControlLabel,
    IconButton,
    Stack,
    TextField,
    Tooltip,
    Typography,
} from "@mui/material";
import "ag-grid-community/styles/ag-grid.css"; // Core CSS
import "ag-grid-community/styles/ag-theme-quartz.css"; // Theme
import { AgGridReact } from "ag-grid-react";
import React, { useCallback, useState } from "react";
import DialogHeader from "./DialogHeader";


const rowHeight = 24;
const headerHeight = 28;
    
const ScrappingCommands = ({page,temp,urlid,rowData,setTemp,setUpdate,update,updateAPI}) => {
    const [openUpdatePrompt, setOpenUpdatePrompt] = useState(false);
    const [csure, setSure] = useState(false);

    const handleClickOpen = () => {
        setOpenUpdatePrompt(true);
      };
    
    const handleClose = () => {
    let updation = { ...update };
    {updation["update_type"]==="prompt" ? updation["prompt"] = temp : updation["prompt"] = "-"}
    {updation["update_type"]==="comment" ? updation["comment"] = temp : updation["comment"] = "-"}
    updateAPI(updation);

    setOpenUpdatePrompt(false);
    setTemp("");
    setSure(false);
    setUpdate({});
    };
    const rendercolDefs1 = useCallback((params) => {
        console.log(params)
        const isScrape = params.data.command === "scrape";
        const updateType = isScrape ? "prompt" : "comment";

        // Extract temp value logic
        const tempValue = isScrape
            ? params.data.prompts || "?"
            : params.data.comments || "-";

        // Extract content logic for update object
        const updateContent = isScrape
            ? params.data.prompt || "-"
            : params.data.comment || "-";

        return (
            <Box className="fx_pc">
            <Tooltip title={isScrape ? "Update Prompt" : "Update Comment"}>
                <IconButton
                className="iconbutton_comment"
                onClick={() => {
                    setTemp(tempValue);
                    setUpdate({
                    step_id: `${params.data.seq}`,
                    url_id: urlid,
                    update_type: updateType,
                    [updateType]: updateContent,
                    });
                    handleClickOpen();
                }}
                >
                {isScrape ? (
                    <EditIcon fontSize="small" className="comment_icon" />
                ) : params.data.command === "open" ? null : (
                    <CommentIcon fontSize="small" className="comment_icon" />
                )}
                </IconButton>
            </Tooltip>
            </Box>
        );
    }, []);

    const [colDefs] = useState(() => {
        const baseColDefs = [
          { headerName: "Seq", field: "seq", minWidth: 60, flex: 1 },
          { headerName: "Command", field: "command", minWidth: 100, flex: 1 },
          { headerName: "XPath", field: "xpath", minWidth: 130, flex: 3 },
          {
            headerName: "Prompts",
            field: "prompts",
            minWidth: 250,
            flex: 2,
          },
          { headerName: "Comments", field: "comments", minWidth: 250, flex: 2 },
        ];
      
        // Conditionally add the first column if page === "approved"
        if (page === "approved") {
          baseColDefs.unshift({
            headerName: "",
            field: "comments",
            value: "1",
            minWidth: 50,
            flex: 1,
            cellStyle: { textAlign: "center" },
            cellRenderer: rendercolDefs1,
          });
        }
      
        return baseColDefs;
    });
      
    return (
    <>
        <Box className="fx_sb ai_end heading_bx">
            <Box>
            <Typography variant="h6" className=" col1 card_title ">
                Scrapping Commands
            </Typography>
            </Box>
        </Box>
        <Box
            className={"ag-theme-quartz  "}
            style={{ width: "100%", height: "173px" }}
        >
            <AgGridReact
            rowData={rowData}
            columnDefs={colDefs}
            rowHeight={rowHeight}
            headerHeight={headerHeight}
            filter={true}
            enableCellTextSelection={true}
            />
        </Box>

        {/* Update prompt/comment pop up */}
        <Box className="comment">
        <Dialog
          open={openUpdatePrompt}
          onClose={() => setOpenUpdatePrompt(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          maxWidth="xs"
          fullWidth
        >

          <DialogHeader
            heading={update.update_type === "prompt" ? "Prompts :" : "Comments :"}
            onClose={() => {
              setOpenUpdatePrompt(false);
            }}
          />

          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <Box className="text_area">
                <Box className="input_field">
                  <TextField
                    id="filled-basic"
                    className="filleddp padding0"
                    variant="filled"
                    multiline
                    name="message"
                    placeholder="Prompts information"
                    fullWidth
                    value={temp}
                    onChange={(event) => setTemp(event.target.value)}
                  />
                </Box>
              </Box>

              <Box py={1}>
                <Stack direction={"row"} justifyContent={"space-between"} alignItems={"center"}>
                  <Box className="checkbox">
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="Are you sure"
                          checked={csure}
                          onChange={() => {
                            setSure(!csure);
                          }}
                          size="small"
                        />
                      }
                      label={
                        <span style={{ fontSize: "12px" }}>
                          Are You Sure You Want To update?
                        </span>
                      }
                    />
                  </Box>

                  <Box>
                    <Button
                      onClick={() => {
                        handleClose();
                      }}
                      autoFocus
                      className="approve_btn"
                      disabled={!csure}
                    >
                      Update & Resend
                    </Button>
                  </Box>
                </Stack>
              </Box>

            </DialogContentText>
          </DialogContent>

        </Dialog>
        </Box>
    </>
    );
};

export default ScrappingCommands;